<script setup lang="ts">
import { Input } from '@zerohuman/ui'

/**
 * The one search field every portal list page draws: the kit `Input`, so its height, radius, focus ring and disabled
 * state come from the v2 theme and from nowhere else. A screen supplies only what is particular to it, as attributes
 * that fall through to the kit field: `type`, `placeholder`, its accessible name (`aria-label`), `data-testid`, `id`
 * and a width or layout class, which the kit merges with its own control classes. How the search is triggered
 * (submit or live) stays with the screen; this field only shows the value and relays what is typed.
 */
defineProps<{ modelValue?: string }>()

const emit = defineEmits<{ 'update:modelValue': [value: string] }>()

function relay(value: string | number): void {
    emit('update:modelValue', String(value))
}
</script>

<template>
	<Input :model-value="modelValue" @update:model-value="relay" />
</template>
